<script setup lang='ts'>
import { useAppStore } from '@/store/useApp'

const appStore = useAppStore()
</script>

<template>
  <div class="relative h-100vh">
    <router-view v-slot="{ Component, route }" class="flex-1 relative z-1 ">
      <transition name="fade-slide" mode="out-in">
        <keep-alive>
          <component :is="Component" v-if="appStore.loadFlag" :key="route.fullPath" />
        </keep-alive>
        <!-- <template v-else>
          <component :is="Component" v-if="appStore.loadFlag" :key="route.fullPath" />
        </template> -->
      </transition>
    </router-view>
  </div>
</template>

<style lang='scss' scoped></style>
